import { SectionProps } from '../types';
import { StyledDefaultSection } from './style';

export const DefaultSection: React.FC<SectionProps> = ({
  sectionName,
  image,
  textColor = 'white',
}) => (
  <StyledDefaultSection className={'section-default'} textColor={textColor}>
    {image && (
      <div>
        <img
          className={'section-default__prefix-image'}
          src={image}
          alt={sectionName + `prefix image`}
        />
      </div>
    )}
    <span className={'section-default__section-name'}>{sectionName}</span>
    {image && (
      <div>
        <img
          className={'section-default__suffix-image'}
          src={image}
          alt={sectionName + `prefix image`}
        />
      </div>
    )}
  </StyledDefaultSection>
);
